// assets/vc-product.js
(() => {
  'use strict';

  // Bind once per page 
  if (window.__vcPdBound) return;
  window.__vcPdBound = true; 
 
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // DOM refs
  let root, titleEl, priceEl, optsEl, descEl, addBtn, buyBtn;
  let sliderEl, trackEl, dotsEl, thumbsEl;
  let prevBtn, nextBtn;
  let qtyInput, qtyInc, qtyDec;

  // Data/state
  let product = null;
  let currentVariant = null;
  let __mediaMap = {};
  let __thumbOpts = new Set(['color']);

  // Slider state
  let __slideIndex = 0;
  let __slideCount = 0;
  let __currentGalleryKey = null; // 'mf:<variantId>' or 'prod:<productId>'

  // Qty/stock state
  let __variantMaxQty = 99;

  /* --------------------------------
     Resolve DOM + load product data
  --------------------------------- */
  async function resolve() {
    root     = $('[data-pd-root]');
    if (!root) return false;

    titleEl  = $('[data-pd-title]');
    priceEl  = $('[data-pd-price]');
    optsEl   = $('[data-pd-options]');
    descEl   = $('[data-pd-desc]');
    addBtn   = $('[data-pd-add]');
    buyBtn   = $('[data-pd-buy]');

    sliderEl = $('[data-pd-slider]');
    trackEl  = $('[data-pd-track]');
    dotsEl   = $('[data-pd-dots]');
    thumbsEl = $('[data-pd-thumbs]');

    prevBtn = document.querySelector('[data-pd-prev]');
    nextBtn = document.querySelector('[data-pd-next]');


    qtyInput = $('[data-pd-input]');
    qtyInc   = $('[data-pd-inc]');
    qtyDec   = $('[data-pd-dec]');

    const pid    = root.getAttribute('data-product-id');
    let handle = root.getAttribute('data-product-handle');


    // Product JSON: fetch from .js endpoint (same as quickview) for consistent data
    // The .js endpoint includes featured_image on variants, inline JSON might not
    if (handle) {
      try {
        const res = await fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`, { credentials:'same-origin' });
        if (res.ok) product = await res.json();
      } catch (e) { 
        console.warn('VC PD: fetch product json failed', e); 
      }
    }
    
    // Fallback to inline JSON if fetch failed
    if (!product) {
      try {
        const inline = document.getElementById(`vc-product-json-${pid}`)?.textContent || '';
        if (inline.trim()) product = JSON.parse(inline);
      } catch (e) {
        console.warn('VC PD: inline product json parse failed', e);
      }
    }
    if (!product) return false;
    
    // Use product.handle if attribute was missing
    if (!handle && product.handle) {
      handle = product.handle;
    }

    // Variant gallery JSON - fetch from endpoint (same as quickview)
    if (handle) {
      try {
        const url = `${ROOT}products/${encodeURIComponent(handle)}?view=variant-galleries.json&ts=${Date.now()}`;
        const res = await fetch(url, { credentials: 'same-origin' });
        const txt = await res.text();
        const parsed = JSON.parse(txt || '{}');
        
        // Extract _inventory if present
        if (parsed._inventory && typeof parsed._inventory === 'object') {
          if (!window.VEDHACART_STOCK) window.VEDHACART_STOCK = {};
          for (const vid in parsed._inventory) {
            window.VEDHACART_STOCK[String(vid)] = Math.max(0, Number(parsed._inventory[vid]) || 0);
          }
          delete parsed._inventory;
        }
        
        __mediaMap = parsed;
      } catch (e) { 
        console.warn('VC PD: failed to load variant galleries', e);
        __mediaMap = {}; 
      }
    }

    // Thumbnail option names (optional config)
    try {
      const cjson = document.getElementById(`vc-pd-config-${pid}`)?.textContent || '{}';
      const cfg = JSON.parse(cjson);
      if (Array.isArray(cfg.thumbnail_options)) {
        __thumbOpts = new Set(cfg.thumbnail_options.map(s => String(s).toLowerCase()));
      }
    } catch {}

    // CTA
    if (addBtn && !addBtn.__bound) {
      addBtn.__bound = true;
      addBtn.addEventListener('click', (e) => { e.preventDefault(); addToCart(); });
    }
    
    // Buy Now CTA
    if (buyBtn && !buyBtn.__bound) {
      buyBtn.__bound = true;
      buyBtn.addEventListener('click', (e) => { e.preventDefault(); buyNow(); });
    }

    bindQty();
    bindResizeOnce();
    bindSliderArrows();
    bindSliderDragging();
    bindZoomFunctionality();
    bindProductTabs();
    bindShareButtons();
    bindReviewSystem();
    updateStockUrgency();
 
    /* ===== Zoom Modal Functionality ===== */
    function bindZoomFunctionality() {
      if (!sliderEl) return;
      if (sliderEl.__zoomBound) return;
      sliderEl.__zoomBound = true;
 
      const modal = document.getElementById('vc-pd-zoom-modal');
      const modalImg = document.getElementById('vc-pd-zoom-img');
      const modalPrev = document.getElementById('vc-pd-zoom-prev');
      const modalNext = document.getElementById('vc-pd-zoom-next');
      const modalClose = document.getElementById('vc-pd-zoom-close');
 
      if (!modal || !modalImg) return;
 
      let currentZoomIndex = 0;
      let zoomImages = [];
 
      // Collect all images for zoom modal
      function collectZoomImages() {
        zoomImages = [];
        const slides = trackEl?.querySelectorAll('.vc-pd-slide img') || [];
        slides.forEach(img => {
          if (img.src) zoomImages.push(img.src);
        });
      }
 
      // Open zoom modal
      function openZoomModal(index = __slideIndex) {
        collectZoomImages();
        currentZoomIndex = Math.min(index, zoomImages.length - 1);
        modalImg.src = zoomImages[currentZoomIndex] || '';
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        updateZoomNavigation();
      }
 
      // Close zoom modal
      function closeZoomModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
 
      // Navigate zoom images
      function navigateZoom(direction) {
        currentZoomIndex = Math.max(0, Math.min(zoomImages.length - 1, currentZoomIndex + direction));
        modalImg.src = zoomImages[currentZoomIndex] || '';
        updateZoomNavigation();
      }
 
      // Update navigation buttons
      function updateZoomNavigation() {
        if (modalPrev) modalPrev.style.opacity = currentZoomIndex > 0 ? '1' : '0.3';
        if (modalNext) modalNext.style.opacity = currentZoomIndex < zoomImages.length - 1 ? '1' : '0.3';
      }
 
      // Click on slider to open zoom
      sliderEl.addEventListener('click', (e) => {
        if (e.target.closest('[data-pd-prev],[data-pd-next]')) return;
        openZoomModal();
      });
 
      // Modal navigation
      if (modalPrev) modalPrev.addEventListener('click', () => navigateZoom(-1));
      if (modalNext) modalNext.addEventListener('click', () => navigateZoom(1));
      if (modalClose) modalClose.addEventListener('click', closeZoomModal);
 
      // Click outside to close
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeZoomModal();
      });
 
      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('active')) return;
 
        if (e.key === 'Escape') closeZoomModal();
        else if (e.key === 'ArrowLeft') navigateZoom(-1);
        else if (e.key === 'ArrowRight') navigateZoom(1);
      });

      // Touch/Swipe support for zoom modal
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const minSwipeDistance = 50;

      modal.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      modal.addEventListener('touchend', (e) => {
        if (!modal.classList.contains('active')) return;
        
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        
        // Only handle horizontal swipes (ignore vertical scrolling)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            // Swiped right - go to previous
            navigateZoom(-1);
          } else {
            // Swiped left - go to next
            navigateZoom(1);
          }
        }
      }, { passive: true });
    }

    return true;
  }

  /* -----------------------
     Gallery helper methods
  ------------------------ */
  function renderImagesFromUrls(urls) {
    if (!trackEl || !sliderEl) return;

    trackEl.innerHTML = '';
    if (dotsEl)   dotsEl.innerHTML = '';
    if (thumbsEl) thumbsEl.innerHTML = '';

    const imgs = (urls || []).filter(Boolean);

    imgs.forEach((src, i) => {
        // slide
        const slide = document.createElement('div');
        slide.className = 'vc-pd-slide';
        slide.innerHTML = `<img alt="" src="${src}">`;
        trackEl.appendChild(slide);

        // dot
        if (dotsEl) {
        const dot = document.createElement('span');
        dot.className = 'vc-pd-dot';
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dotsEl.appendChild(dot);
        }

        // thumb
        if (thumbsEl) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'vc-pd-thumb';
        b.innerHTML = `<img alt="" src="${src}">`;
        b.addEventListener('click', () => setSlideIndex(i));
        if (i === 0) b.setAttribute('aria-pressed', 'true');
        thumbsEl.appendChild(b);
        }
    });

    __slideCount = imgs.length;

    // Helper to update slider height
    function updateSliderHeight() {
      const currentSlide = trackEl.querySelector('.vc-pd-slide');
      if (currentSlide) {
        const img = currentSlide.querySelector('img');
        if (img && img.naturalHeight > 0) {
          sliderEl.style.height = currentSlide.offsetHeight + 'px';
        }
      }
    }

    // Defer the first snap until the layout has a width
    requestAnimationFrame(() => {
        setSlideIndex(0, { animate:false });
        updateArrowState();

        // Wait for first image to load before setting height
        const firstImg = trackEl.querySelector('.vc-pd-slide img');
        if (firstImg) {
          if (firstImg.complete && firstImg.naturalHeight > 0) {
            // Image already loaded
            updateSliderHeight();
          } else {
            // Wait for image to load
            firstImg.addEventListener('load', updateSliderHeight, { once: true });
            // Fallback timeout in case load event doesn't fire
            setTimeout(updateSliderHeight, 500);
          }
        }
    });
  }

  function slideWidth() {
    // Use slider container width for consistent positioning
    const wWrap = sliderEl ? sliderEl.getBoundingClientRect().width : 0;
    return Math.max(wWrap, 1);
  }

  function updateArrowState() {
    if (!prevBtn || !nextBtn) return;
    const atStart = (__slideIndex <= 0);
    const atEnd   = (__slideIndex >= (__slideCount - 1));
    const single  = (__slideCount <= 1);
    prevBtn.disabled = atStart || single;
    nextBtn.disabled = atEnd   || single;
  }

  function setSlideIndex(i, { animate=true } = {}) {
    if (!trackEl || !sliderEl) return;
    __slideIndex = Math.max(0, Math.min(__slideCount - 1, i));
    trackEl.style.transition = animate ? 'transform 280ms ease' : 'none';

    // Ensure we have the correct width after any layout changes
    requestAnimationFrame(() => {
      const w = slideWidth();
      trackEl.style.transform = `translateX(${-__slideIndex * w}px)`;

      // Set slider height to match current slide height (not track height)
      requestAnimationFrame(() => {
        const slides = trackEl.querySelectorAll('.vc-pd-slide');
        const currentSlide = slides[__slideIndex];
        if (currentSlide) {
          const img = currentSlide.querySelector('img');
          if (img && img.complete && img.naturalHeight > 0) {
            sliderEl.style.height = currentSlide.offsetHeight + 'px';
          } else if (img) {
            // Wait for image to load
            img.addEventListener('load', () => {
              sliderEl.style.height = currentSlide.offsetHeight + 'px';
            }, { once: true });
          }
        }
      });
    });

    if (dotsEl) {
        Array.from(dotsEl.children).forEach((d, di) => {
        if (di === __slideIndex) d.setAttribute('aria-current','true');
        else d.removeAttribute('aria-current');
        });
    }
    if (thumbsEl) {
        Array.from(thumbsEl.children).forEach((b, bi) => {
        if (bi === __slideIndex) b.setAttribute('aria-pressed','true');
        else b.removeAttribute('aria-pressed');
        });
    }

    updateArrowState();
  }

  /* ===== Swipe / Drag ===== */
  function bindSliderDragging() {
    if (!sliderEl || !trackEl) return;
    if (sliderEl.__dragBound) return;
    sliderEl.__dragBound = true;

    let startX = 0, currentX = 0, startTranslate = 0;
    let dragging = false, draggedDistance = 0;

    const width  = () => slideWidth();
    const apply  = (x) => { trackEl.style.transform = `translateX(${x}px)`; };

    const onPointerDown = (e) => {
        // don't start dragging if clicking on arrows
        if (e.target.closest('[data-pd-prev],[data-pd-next]')) return;

        if (e.pointerType === 'mouse' && e.button !== 0) return;
        sliderEl.setPointerCapture?.(e.pointerId);
        dragging = true;
        draggedDistance = 0;
        startX = e.clientX;
        currentX = e.clientX;
        startTranslate = -__slideIndex * width();
        trackEl.style.transition = 'none';
    };


    const onPointerMove = (e) => {
        if (!dragging) return;
        currentX = e.clientX;
        const delta = currentX - startX;
        draggedDistance = Math.max(draggedDistance, Math.abs(delta));
        apply(startTranslate + delta);
    };

    const onPointerUp = () => {
        if (!dragging) return;
        dragging = false;
        const delta = currentX - startX;
        const threshold = Math.max(40, width() * 0.15);
        trackEl.style.transition = 'transform 280ms ease';

        if (delta > threshold) setSlideIndex(__slideIndex - 1);
        else if (delta < -threshold) setSlideIndex(__slideIndex + 1);
        else setSlideIndex(__slideIndex);
    };

    // Don’t mark as passive; we might want to preventDefault later if needed.
    sliderEl.addEventListener('pointerdown', onPointerDown);
    sliderEl.addEventListener('pointermove', onPointerMove);
    sliderEl.addEventListener('pointerup', onPointerUp);
    sliderEl.addEventListener('pointercancel', onPointerUp);

    // keep alignment on resize/rotation
    window.addEventListener('resize', () => {
      // Small delay to ensure layout is complete
      setTimeout(() => setSlideIndex(__slideIndex, { animate:false }), 50);
    });
  }


  /* ===== Arrows ===== */
  function bindSliderArrows() {
    if (!prevBtn || !nextBtn) return;
    if (prevBtn.__bound) return;

    prevBtn.__bound = nextBtn.__bound = true;

    prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (prevBtn.disabled) return;
        setSlideIndex(__slideIndex - 1);
    });

    nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (nextBtn.disabled) return;
        setSlideIndex(__slideIndex + 1);
    });

    // Optional keyboard support
    document.addEventListener('keydown', (e) => {
        const open = true; // always active on PDP
        if (!open || e.altKey || e.ctrlKey || e.metaKey) return;
        if (e.key === 'ArrowLeft')  { e.preventDefault(); setSlideIndex(__slideIndex - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setSlideIndex(__slideIndex + 1); }
    });
  }


  function bindResizeOnce() {
    if (window.__vcPdResizeBound) return;
    window.__vcPdResizeBound = true;
    window.addEventListener('resize', () => {
      // Small delay to ensure layout is complete
      setTimeout(() => {
        setSlideIndex(__slideIndex, { animate:false });
        // setSlideIndex now handles height correctly
      }, 50);
    }, { passive:true });
  }

  /* -------------------
     Qty / stock helpers
  -------------------- */
  function resetQtyControls(initial = 1) {
    if (!qtyInput) return;
    qtyInput.value = String(initial);
    qtyInput.min = '1';
    qtyInput.step = '1';
  }

  function getRawStock(variantId) {
    const n = Number(window.VEDHACART_STOCK?.[String(variantId)]);
    if (!Number.isFinite(n)) return 99; // treat unknown as "large"
    return Math.max(0, n);
  }

  function getLiveMax() {
    const maxAttr = Number(qtyInput?.max);
    if (Number.isFinite(maxAttr) && maxAttr > 0) return maxAttr;
    return __variantMaxQty || 1;
  }

  function setQtyMax(n) {
    __variantMaxQty = Math.max(1, Number(n) || 1);
    if (!qtyInput) return;
    qtyInput.max = String(__variantMaxQty);
    const cur = Number(qtyInput.value || 1);
    if (cur > __variantMaxQty) qtyInput.value = String(__variantMaxQty);
    toggleQtyButtons();
  }

  function toggleQtyButtons() {
    if (!qtyInput) return;
    const cur = Number(qtyInput.value || 1);
    const cap = getLiveMax();
    if (qtyDec) qtyDec.disabled = (cur <= 1);
    if (qtyInc) qtyInc.disabled = (cur >= cap);
  }

  function bindQty() {
    if (!qtyInput || qtyInput.__bound) return;
    qtyInput.__bound = true;

    const clamp = (n) => {
      const cap = getLiveMax();
      const x = Number(n) || 1;
      return Math.max(1, Math.min(cap, x));
    };

    qtyInc?.addEventListener('click', () => {
      qtyInput.value = String(clamp((+qtyInput.value || 1) + 1));
      toggleQtyButtons();
    });
    qtyDec?.addEventListener('click', () => {
      qtyInput.value = String(clamp((+qtyInput.value || 1) - 1));
      toggleQtyButtons();
    });
    qtyInput.addEventListener('input', () => {
      qtyInput.value = String(clamp(qtyInput.value));
      toggleQtyButtons();
    });

    qtyInput.min = '1';
    qtyInput.step = '1';
  }

  function currentQty() {
    if (!qtyInput) return 1;
    const n = Number(qtyInput.value || 1);
    return Math.max(1, Math.min(__variantMaxQty, isNaN(n) ? 1 : n));
  }

  /* ---------------------
     Variant image helpers (same as quickview)
  ---------------------- */
  // ONLY the metafield gallery URLs for a variant id (no fallback here)
  function getVariantGalleryUrlsFromMap(variantId) {
    const raw = __mediaMap?.[String(variantId)];
    if (!Array.isArray(raw)) return [];
    return raw.filter(Boolean);
  }

  // Product-wide images list
  function productImageUrls(prod) {
    const raw = Array.isArray(prod.images) && prod.images.length
      ? prod.images
      : (prod.featured_image ? [prod.featured_image] : []);
    return raw.map(im => (typeof im === 'string' ? im : (im?.src || ''))).filter(Boolean);
  }

  // Images filtered by color.
  // Uses each color's representative variant.featured_image to find its start position
  // in product.images, then slices to the next color's start.
  function colorFilteredImageUrls(prod, variant) {
    if (!Array.isArray(prod.images) || !prod.images.length) return productImageUrls(prod);
    const options = Array.isArray(prod.options) ? prod.options : [];
    const colorIdx = options.findIndex(o => /colou?r/i.test(String(o)));
    if (colorIdx === -1 || !Array.isArray(variant.options)) return productImageUrls(prod);
    const selectedColor = variant.options[colorIdx];
    if (!selectedColor) return productImageUrls(prod);

    // Unique colors in variant order
    const colorsSeen = new Set();
    const colorOrder = [];
    for (const v of prod.variants) {
      const c = Array.isArray(v.options) ? v.options[colorIdx] : null;
      if (c && !colorsSeen.has(c)) { colorOrder.push(c); colorsSeen.add(c); }
    }
    if (colorOrder.length <= 1) return productImageUrls(prod);

    // For each color, find where its images start using featured_image
    const colorStart = {};
    for (const color of colorOrder) {
      const rep = prod.variants.find(v => Array.isArray(v.options) && v.options[colorIdx] === color);
      const fi = rep?.featured_image;
      if (!fi) continue;

      // Match by src (strip query string for comparison)
      const fiBase = (fi.src || '').split('?')[0];
      let idx = prod.images.findIndex(img => {
        const imgBase = (typeof img === 'string' ? img : img?.src || '').split('?')[0];
        return imgBase && imgBase === fiBase;
      });

      // Fallback: match by position field
      if (idx === -1 && fi.position) {
        idx = prod.images.findIndex(img => img.position === fi.position);
      }

      if (idx !== -1) colorStart[color] = idx;
    }

    if (colorStart[selectedColor] == null) return productImageUrls(prod);

    const sortedStarts = Object.values(colorStart).sort((a, b) => a - b);
    const myStart = colorStart[selectedColor];
    const myPos   = sortedStarts.indexOf(myStart);
    const myEnd   = myPos < sortedStarts.length - 1 ? sortedStarts[myPos + 1] : prod.images.length;

    const urls = prod.images.slice(myStart, myEnd)
      .map(img => typeof img === 'string' ? img : (img?.src || '')).filter(Boolean);
    return urls.length ? urls : productImageUrls(prod);
  }

  // First image to preview for an option chip (metafield-first, else product)
  function firstImageForVariant(prod, variant) {
    const mf = getVariantGalleryUrlsFromMap(variant.id);
    if (mf.length) return mf[0];
    if (variant?.featured_image?.src) return variant.featured_image.src;
    const prodImages = productImageUrls(prod);
    return prodImages[0] || '';
  }

  function galleryKey(prod, variant) {
    const mf = getVariantGalleryUrlsFromMap(variant.id);
    if (mf.length) return `mf:${variant.id}`;
    const options = Array.isArray(prod.options) ? prod.options : [];
    const colorIdx = options.findIndex(o => /colou?r/i.test(String(o)));
    if (colorIdx !== -1 && Array.isArray(variant.options) && variant.options[colorIdx]) {
      return `color:${variant.options[colorIdx]}`;
    }
    return `prod:${prod.id}`;
  }

  /* ---------------------
     Variant chips helpers
  ---------------------- */
  function normalizeOptions(prod) {
    if (Array.isArray(prod.options_with_values) && prod.options_with_values.length) {
      return prod.options_with_values;
    }
    const names    = Array.isArray(prod.options)  ? prod.options  : [];
    const variants = Array.isArray(prod.variants) ? prod.variants : [];

    return names.map((name, idx) => {
      const values = Array.from(new Set(
        variants
          .map(v => Array.isArray(v.options) ? v.options[idx] : v[`option${idx+1}`])
          .filter(Boolean)
      ));
      return { name, position: idx + 1, values };
    });
  }

  function buildOptionsUI(prod) {
    optsEl.innerHTML = '';

    const list = normalizeOptions(prod);
    const isDefaultSingle =
      list.length === 1 &&
      String(list[0]?.name || '').toLowerCase() === 'title' &&
      (list[0]?.values || []).length === 1 &&
      String(list[0].values[0]).toLowerCase() === 'default title';
    if (!list.length || isDefaultSingle) return;

    const start = prod.variants.find(v => v.available) || prod.variants[0];
    const selected = (start?.options || []).slice();
    const groups = [];

    // Define info-only options (single-value options displayed as text, not selectable)
    const infoOnlyOptions = new Set(['material', 'fabric', 'composition']);

    list.forEach((opt, idx) => {
      const optNameLower = String(opt.name || '').toLowerCase();
      const values = opt.values || [];
      const isSingleValue = values.length === 1;
      const isInfoOnly = isSingleValue && infoOnlyOptions.has(optNameLower);

      const wrap  = document.createElement('div');
      wrap.className = 'vc-pd-option';

      const label = document.createElement('div');
      label.className = 'vc-pd-option-label';
      label.textContent = (opt.name || 'Option') + ':';

      // If single-value info option, display as formatted composition list
      if (isInfoOnly) {
        wrap.classList.add('vc-pd-option--info');
        
        // Parse material composition (e.g., "60%Cotton+35%Polyester+5%Elastane")
        const rawValue = values[0];
        const parsed = parseMaterialComposition(rawValue);
        
        const infoContainer = document.createElement('div');
        infoContainer.className = 'vc-pd-material-list';
        
        if (parsed.length > 0) {
          parsed.forEach(item => {
            const line = document.createElement('div');
            line.className = 'vc-pd-material-item';
            line.innerHTML = `<span class="vc-pd-material-percent">${item.percent}%</span><span class="vc-pd-material-name">${item.name}</span>`;
            infoContainer.appendChild(line);
          });
        } else {
          // Fallback if parsing fails
          infoContainer.textContent = rawValue;
          infoContainer.className = 'vc-pd-option-info-text';
        }
        
        wrap.appendChild(label);
        wrap.appendChild(infoContainer);
        optsEl.appendChild(wrap);
        // Still track selection for variant resolution
        selected[idx] = values[0];
        return; // Skip adding to groups - no interaction needed
      }

      const group = document.createElement('div');
      group.className = 'vc-pd-option-group';

      const isThumbType = __thumbOpts.has(optNameLower);

      values.forEach(val => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vc-pd-swatch';
        btn.dataset.optIndex = idx;
        btn.dataset.optValue = val;

        if (isThumbType) {
          // representative variant for this value (same as quickview)
          const rep = prod.variants.find(v => v.options[idx] === val);
          const preview = rep ? firstImageForVariant(prod, rep) : '';

          btn.classList.add('vc-pd-swatch--thumb');
          btn.innerHTML = preview
            ? `<img alt="${val}" src="${preview}" class="vc-pd-swatch-img"><span class="vc-pd-swatch-label">${val}</span>`
            : `<span class="vc-pd-swatch-label">${val}</span>`;
        } else {
          btn.textContent = val;
        }

        btn.addEventListener('click', () => {
          selected[idx] = val;
          updateStates();
        });

        group.appendChild(btn);
      });

      wrap.appendChild(label);
      wrap.appendChild(group);
      optsEl.appendChild(wrap);
      groups.push({ group, idx });
    });

    // Parse material composition string like "60%Cotton+35%Polyester+5%Elastane"
    function parseMaterialComposition(str) {
      if (!str || typeof str !== 'string') return [];
      
      // Split by + or , or ; or spaces between components
      const parts = str.split(/[+,;]|\s+(?=\d)/).map(s => s.trim()).filter(Boolean);
      const result = [];
      
      for (const part of parts) {
        // Match patterns like "60%Cotton", "60% Cotton", "Cotton 60%", "60 Cotton"
        const match = part.match(/(\d+)\s*%?\s*([A-Za-z]+)|([A-Za-z]+)\s*(\d+)\s*%?/);
        if (match) {
          const percent = match[1] || match[4];
          const name = match[2] || match[3];
          if (percent && name) {
            result.push({ percent: percent, name: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() });
          }
        }
      }
      
      return result;
    }

    function updateStates() {
      // 1) Enable/disable + selected styling per chip
      groups.forEach(({ group, idx }) => {
        Array.from(group.querySelectorAll('.vc-pd-swatch')).forEach(btn => {
          const val = btn.dataset.optValue;
          const isSelected = selected[idx] === val;

          const variantForVal = prod.variants.find(v => v.options[idx] === val);
          const variantId = variantForVal ? String(variantForVal.id) : null;

          const possible = prod.variants.some(v =>
            v.available && v.options.every((vv, i) => (i === idx ? val : selected[i]) === vv)
          );

          const rawStock = variantId && window.VEDHACART_STOCK
            ? Number(window.VEDHACART_STOCK[variantId]) || 0
            : 0;

          const inStock = rawStock > 0 && !!variantForVal?.available;
          const disabled = !possible || !inStock;

          btn.disabled = disabled;
          btn.classList.toggle('is-outofstock', !inStock);
          btn.classList.toggle('is-selected', isSelected);
          if (isSelected) btn.setAttribute('aria-pressed', 'true');
          else btn.removeAttribute('aria-pressed');
        });
      });

      // 2) Resolve concrete variant from current selection
      const v = prod.variants.find(v =>
        v.options.every((val, i) => !selected[i] || selected[i] === val)
      ) || prod.variants[0];

      currentVariant = v || null;
      if (!v) return;

      // 3) Qty & stock
      resetQtyControls(1);
      const stock = getRawStock(v.id);
      setQtyMax(stock > 0 ? stock : 1);
      toggleQtyButtons();

      // 4) Price and button states based on stock
      const isOutOfStock = !v.available || (stock !== null && stock <= 0);
      
      if (isOutOfStock) {
        priceEl.textContent = 'Sold out';
        // Change Add to Cart to "Sold out" and disable
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.classList.add('is-disabled');
          addBtn.dataset.originalText = addBtn.dataset.originalText || addBtn.textContent;
          addBtn.textContent = 'Sold out';
        }
        // Hide Buy Now button
        if (buyBtn) {
          buyBtn.style.display = 'none';
        }
      } else {
        const regularPrice = money(v.price);
        const comparePrice = v.compare_at_price ? money(v.compare_at_price) : null;

        if (comparePrice && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
          priceEl.innerHTML = `
            <span class="vc-pd-price-sale">${regularPrice}</span>
            <span class="vc-pd-price-compare">${comparePrice}</span>
          `;
        } else {
          priceEl.innerHTML = regularPrice;
        }
        // Restore Add to Cart button
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.classList.remove('is-disabled');
          if (addBtn.dataset.originalText) {
            addBtn.textContent = addBtn.dataset.originalText;
          }
        }
        // Show Buy Now button
        if (buyBtn) {
          buyBtn.style.display = '';
        }
      }

      // 5) Gallery (metafield-first, then color-filtered)
      const urlsFromMap  = getVariantGalleryUrlsFromMap(v.id);
      const urlsToRender = urlsFromMap.length ? urlsFromMap : colorFilteredImageUrls(prod, v);
      const nextKey      = galleryKey(prod, v);

      if (__currentGalleryKey !== nextKey) {
        const prevIndex = __slideIndex;
        renderImagesFromUrls(urlsToRender);

        // try to land on the variant's featured image when entering a metafield gallery
        let jumpIdx = -1;
        if (urlsFromMap.length && v.featured_media?.src) {
          jumpIdx = urlsToRender.findIndex(u => u.includes(v.featured_media.src));
        }

        if (jumpIdx >= 0) {
          setSlideIndex(jumpIdx, { animate:false });
        } else if (nextKey.startsWith('prod:') &&
                   __currentGalleryKey &&
                   __currentGalleryKey.startsWith('prod:')) {
          setSlideIndex(prevIndex, { animate:false });
        } else {
          setSlideIndex(0, { animate:false });
        }

        __currentGalleryKey = nextKey;
      } else {
        // gallery unchanged -> just ensure dots/thumbs are in sync
        setSlideIndex(__slideIndex, { animate:false });
      }

      // 6) Update stock urgency for new variant
      updateStockUrgency(v);
    }

    updateStates();
  }

  function money(cents) {
    try {
      const amt = cents / 100;
      const cur = (Shopify && Shopify.currency && (Shopify.currency.active || Shopify.currency)) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:cur }).format(amt);
    } catch { return (cents / 100).toFixed(2); }
  }

async function refreshCartUI() {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

    const selectors = ['[data-cart-count]', '#cart-count', '.cart-count', '.header-cart-count', '#mCartCount'];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = String(count);
        el.setAttribute?.('aria-label', `Cart items: ${count}`);
        el.hidden = count === 0;
      });
    });

    // Let other parts of the theme/apps react
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  } catch (e) {
    console.warn('VC QV: refreshCartUI failed', e);
  }
}


  async function addToCart() {
    try {
      if (!currentVariant?.id) return;

      if (!currentVariant.available) return;
      const qty = currentQty();
      addBtn?.setAttribute('aria-busy','true');

      const body = new URLSearchParams();
      body.set('id', String(currentVariant.id));
      body.set('quantity', String(qty));

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept':'application/json', 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8' },
        body
      });

      if (!res.ok) {
        let msg = 'Add to cart failed';
        try { const data = await res.json(); msg = data?.description || data?.message || msg; } catch(_){}
        alert(msg);
        return;
      }

      addBtn.textContent = 'Added!';
      setTimeout(() => addBtn.textContent = 'Add to cart', 700);

      refreshCartUI();

      document.dispatchEvent(new Event('vc:cart:updated'));
      await window.VCCartbox?.refreshCartbox?.();        // await to avoid race
      await window.VCCartbox?.refreshReserveFlag?.();
      if (typeof window.openCartDrawer === 'function') {
        try { window.openCartDrawer(); } catch(_){}
      }
    } finally {
      addBtn?.removeAttribute('aria-busy');
    }
  }

  // Buy Now - Skip cart and go directly to checkout
  async function buyNow() {
    if (!currentVariant?.id) return;
    if (!currentVariant.available) return;
    
    const qty = currentQty();
    
    try {
      // Fetch current cart to check if it has items
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();

      // If cart is empty, skip modal and go straight to checkout
      if (cart.item_count === 0) {
        await buyNowCheckout('item', qty);
      } else {
        showBuyNowModal(cart, qty);
      }
    } catch (e) {
      console.error('Buy now error:', e);
      // Fallback: go directly to checkout
      await buyNowCheckout('item', qty);
    }
  }
  
  // Show the Buy Now modal
  function showBuyNowModal(cart, qty) {
    const modal = document.getElementById('vc-pd-buynow-modal');
    if (!modal) {
      console.error('Buy now modal not found');
      return;
    }
    
    // Calculate item price
    const itemPrice = currentVariant.price * qty;
    const itemTitle = product.title + (currentVariant.title !== 'Default Title' ? ' - ' + currentVariant.title : '');
    
    // Update "This item only" option
    document.getElementById('buynow-item-desc').textContent = itemTitle + ' × ' + qty;
    document.getElementById('buynow-item-price').textContent = money(itemPrice);
    
    // Handle cart option based on whether cart has items
    const cartOption = document.getElementById('buynow-cart-option');
    const cartCountEl = document.getElementById('buynow-cart-count');
    const cartDescEl = document.getElementById('buynow-cart-desc');
    const cartPriceEl = document.getElementById('buynow-cart-price');
    
    if (cart.item_count === 0) {
      // Cart is empty - hide the cart option
      if (cartOption) cartOption.style.display = 'none';
    } else {
      // Cart has items - show cart option with details
      if (cartOption) cartOption.style.display = 'flex';
      
      const cartTotalWithItem = cart.total_price + itemPrice;
      const cartCountWithItem = cart.item_count + qty;
      
      cartCountEl.textContent = cartCountWithItem;
      cartDescEl.textContent = 'Including this item';
      cartPriceEl.textContent = money(cartTotalWithItem) + ' total';
    }
    
    // Store qty for later
    modal.dataset.qty = qty;
    
    // Show modal
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    
    // Setup event listeners (only once)
    if (!modal.__bound) {
      modal.__bound = true;
      
      // Close buttons
      modal.querySelectorAll('[data-buynow-close]').forEach(btn => {
        btn.addEventListener('click', closeBuyNowModal);
      });
      
      // Option buttons
      modal.querySelector('[data-buynow-option="item"]').addEventListener('click', async () => {
        const qty = parseInt(modal.dataset.qty) || 1;
        closeBuyNowModal();
        await buyNowCheckout('item', qty);
      });
      
      modal.querySelector('[data-buynow-option="cart"]').addEventListener('click', async () => {
        const qty = parseInt(modal.dataset.qty) || 1;
        closeBuyNowModal();
        await buyNowCheckout('cart', qty);
      });
      
      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) {
          closeBuyNowModal();
        }
      });
    }
  }
  
  // Close the Buy Now modal
  function closeBuyNowModal() {
    const modal = document.getElementById('vc-pd-buynow-modal');
    if (modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
  }
  
  // Save current cart to localStorage so it can be restored after buy now checkout
  async function saveBuyNowCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const items = (cart.items || []).map(i => ({ id: i.variant_id, quantity: i.quantity }));
      localStorage.setItem('vc_buynow_restore', JSON.stringify(items));
    } catch (e) {
      localStorage.setItem('vc_buynow_restore', '[]');
    }
  }

  // Restore cart saved before buy now (called on return from checkout)
  async function restoreBuyNowCart() {
    const saved = localStorage.getItem('vc_buynow_restore');
    if (saved === null) return;
    localStorage.removeItem('vc_buynow_restore');
    try {
      await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
      const items = JSON.parse(saved);
      for (const item of items) {
        if (!item.id || !item.quantity) continue;
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ id: String(item.id), quantity: String(item.quantity) })
        });
      }
      document.dispatchEvent(new Event('vc:cart:updated'));
    } catch (e) {
      console.error('Failed to restore cart after buy now:', e);
    }
  }

  // Execute checkout based on option
  async function buyNowCheckout(option, qty) {
    buyBtn?.setAttribute('aria-busy', 'true');
    const originalText = buyBtn?.textContent;
    if (buyBtn) buyBtn.textContent = 'Processing...';

    try {
      if (option === 'item') {
        // Save current cart so it's not permanently modified
        await saveBuyNowCart();

        // Clear cart and add only this item (silently — no cart UI update)
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });

        const body = new URLSearchParams();
        body.set('id', String(currentVariant.id));
        body.set('quantity', String(qty));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept':'application/json', 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8' },
          body
        });

        if (!res.ok) throw new Error('Failed to add item');

      } else {
        // "With cart" option — add item to existing cart normally
        const body = new URLSearchParams();
        body.set('id', String(currentVariant.id));
        body.set('quantity', String(qty));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept':'application/json', 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8' },
          body
        });

        if (!res.ok) throw new Error('Failed to add item');
      }

      // Redirect to checkout
      window.location.href = '/checkout';

    } catch (e) {
      console.error('Checkout error:', e);
      // Clean up restore flag if something went wrong
      localStorage.removeItem('vc_buynow_restore');
      alert('Unable to process. Please try again.');
      if (buyBtn) buyBtn.textContent = originalText || 'Buy now';
      buyBtn?.removeAttribute('aria-busy');
    }
  }

  async function init() {
    const ok = await resolve();
    if (!ok) return;

    // Restore cart if returning from a buy now checkout
    restoreBuyNowCart();

    // Reset Buy Now button state (in case user came back from checkout)
    if (buyBtn) {
      buyBtn.textContent = 'Buy now';
      buyBtn.removeAttribute('aria-busy');
      buyBtn.disabled = false;
    }

    titleEl.textContent = product.title || '—';

    // initial price (min available)
    const avail = product.variants.filter(v => v.available);
    if (avail.length) {
      const minPrice = avail.reduce((m, v) => Math.min(m, v.price), avail[0].price);
      const minVariant = avail.find(v => v.price === minPrice);
      const comparePrice = minVariant?.compare_at_price ? money(minVariant.compare_at_price) : null;

      if (comparePrice && parseFloat(minVariant.compare_at_price) > parseFloat(minPrice)) {
        priceEl.innerHTML = `
          <span class="vc-pd-price-sale">${money(minPrice)}</span>
          <span class="vc-pd-price-compare">${comparePrice}</span>
        `;
      } else {
        priceEl.textContent = money(minPrice);
      }
    } else {
      priceEl.textContent = 'Sold out';
    }

    // initial gallery: prefer available variant; metafield-first, then color-filtered
    const startVariant = product.variants.find(v => v.available) || product.variants[0];
    const mf = startVariant ? getVariantGalleryUrlsFromMap(startVariant.id) : [];
    const startUrls = (mf && mf.length) ? mf : (startVariant ? colorFilteredImageUrls(product, startVariant) : productImageUrls(product));
    __currentGalleryKey = startVariant ? galleryKey(product, startVariant) : null;
    renderImagesFromUrls(startUrls);

    // build chips + qty
    buildOptionsUI(product);
    toggleQtyButtons();
  }

  /* ===== Product Tabs ===== */
  function bindProductTabs() {
    const tabButtons = document.querySelectorAll('.vc-pd-tab-btn');
    const tabPanels = document.querySelectorAll('.vc-pd-tab-panel');

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabName = button.getAttribute('data-tab');

        // Update button states
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Update panel states
        tabPanels.forEach(panel => {
          panel.classList.toggle('active', panel.getAttribute('data-tab') === tabName);
        });
      });
    });
  }

  // Global function to switch to Reviews tab and scroll to reviews list
  window.switchToReviewsTab = function() {
    const tabButtons = document.querySelectorAll('.vc-pd-tab-btn');
    const tabPanels = document.querySelectorAll('.vc-pd-tab-panel');
    const reviewsTab = Array.from(tabButtons).find(btn => btn.getAttribute('data-tab') === 'reviews');

    if (reviewsTab) {
      // Update button states
      tabButtons.forEach(btn => btn.classList.remove('active'));
      reviewsTab.classList.add('active');

      // Update panel states
      tabPanels.forEach(panel => {
        panel.classList.toggle('active', panel.getAttribute('data-tab') === 'reviews');
      });

      // Scroll to reviews list within the Reviews tab
      setTimeout(() => {
        const reviewsList = document.querySelector('.vc-pd-reviews-list') || document.getElementById('reviews-list');
        if (reviewsList) {
          reviewsList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Fallback to tab button if reviews list not found
          reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 100); // Small delay to ensure tab content is visible
    }
  };

  /* ===== Share Buttons ===== */
  function bindShareButtons() {
    // These functions are called from onclick attributes in HTML
    window.shareOnWhatsApp = function() {
      const url = encodeURIComponent(window.location.href);
      const text = encodeURIComponent(`Check out this product: ${document.title}`);
      const whatsappUrl = `https://wa.me/?text=${text}%20${url}`;
      window.open(whatsappUrl, '_blank');
    };

    window.copyShareLink = function(e) {
      const btn = e?.target?.closest?.('button') || e?.target;
      const originalText = btn ? btn.innerHTML : null;
      
      function showCopied() {
        if (btn) {
          btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7"/></svg> Copied!`;
          btn.style.color = '#22c55e';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.style.color = '';
          }, 1500);
        }
      }
      
      navigator.clipboard.writeText(window.location.href).then(() => {
        showCopied();
      }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = window.location.href;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showCopied();
      });
    };

    window.openLocationSelector = function() {
      // Placeholder for location selector functionality
      alert('Location selector would open here');
    };
  }

  /* ===== Stock Urgency ===== */
  function updateStockUrgency(variant = currentVariant) {
    const urgencyEl = document.getElementById('stock-urgency');
    if (!urgencyEl || !variant) return;

    // Get actual inventory from VEDHACART_STOCK or variant data
    const stock = getRawStock(variant.id);

    // Show urgency if less than 5 items in stock
    if (stock > 0 && stock <= 5) {
      const stockText = stock === 1 ? 'Only 1 left in stock' : `Only ${stock} left in stock`;
      urgencyEl.querySelector('.vc-pd-stock-text').textContent = `${stockText} - Hurry!`;
      urgencyEl.style.display = 'block';
    } else {
      urgencyEl.style.display = 'none';
    }
  }

  /* ===== Review System ===== */
  function bindReviewSystem() {
    // These functions are called from onclick attributes in HTML
    window.toggleReviewForm = function() {
      const form = document.getElementById('review-form');
      const isVisible = form.style.display !== 'none';
      form.style.display = isVisible ? 'none' : 'block';

      if (!isVisible) {
        // Scroll to form when opening
        form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    window.submitReview = async function(event) {
      event.preventDefault();

      // Check if customer is logged in
      const section = document.querySelector('[data-section-type="vc-product"]') || document.querySelector('#vcp-root');
      const customerId = section?.dataset.customerId;
      const customerEmail = section?.dataset.customerEmail;

      if (!customerId) {
        // Show error notification
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          padding: 16px;
          z-index: 10000;
          max-width: 400px;
          font-family: Arial, sans-serif;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(-20px);
          transition: all 0.3s ease;
        `;
        notification.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 18px; font-weight: bold;">✕</span>
            <span>Please log in to submit a review</span>
            <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
          </div>
        `;
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.style.opacity = '1';
          notification.style.transform = 'translateY(0)';
        }, 10);
        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-20px)';
            setTimeout(() => notification.remove(), 300);
          }
        }, 5000);

        setTimeout(() => {
          window.location.href = '/account/login';
        }, 2000);
        return;
      }

      const form = event.target;
      const formData = new FormData(form);

      const rating = formData.get('rating');
      const author = formData.get('author');
      const content = formData.get('content');

      // Basic validation
      if (!rating) {
        // Show error notification
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          padding: 16px;
          z-index: 10000;
          max-width: 400px;
          font-family: Arial, sans-serif;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(-20px);
          transition: all 0.3s ease;
        `;
        notification.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 18px; font-weight: bold;">✕</span>
            <span>Please select a rating</span>
            <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
          </div>
        `;
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.style.opacity = '1';
          notification.style.transform = 'translateY(0)';
        }, 10);
        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-20px)';
            setTimeout(() => notification.remove(), 300);
          }
        }, 5000);
        return;
      }

      // Validate name field for all users
      if (!author.trim()) {
        // Show error notification
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          padding: 16px;
          z-index: 10000;
          max-width: 400px;
          font-family: Arial, sans-serif;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(-20px);
          transition: all 0.3s ease;
        `;
        notification.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 18px; font-weight: bold;">✕</span>
            <span>Please enter your name</span>
            <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
          </div>
        `;
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.style.opacity = '1';
          notification.style.transform = 'translateY(0)';
        }, 10);
        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-20px)';
            setTimeout(() => notification.remove(), 300);
          }
        }, 5000);
        return;
      }

      if (!content.trim()) {
        // Show error notification
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          padding: 16px;
          z-index: 10000;
          max-width: 400px;
          font-family: Arial, sans-serif;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(-20px);
          transition: all 0.3s ease;
        `;
        notification.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 18px; font-weight: bold;">✕</span>
            <span>Please enter your review</span>
            <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
          </div>
        `;
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.style.opacity = '1';
          notification.style.transform = 'translateY(0)';
        }, 10);
        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-20px)';
            setTimeout(() => notification.remove(), 300);
          }
        }, 5000);
        return;
      }

      // Collect images
      const imagePreview = document.getElementById('image-preview');
      const imageFiles = imagePreview ? Array.from(imagePreview.children).map(item => item._file).filter(Boolean) : [];

      // Create review object
      const review = {
        rating: parseInt(rating),
        author: author.trim(), 
        content: content.trim(),
        images: imageFiles // Will be processed by backend
      };

      // Show loading state
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Submitting...';
      submitBtn.disabled = true;

      try {
        // Use the centralized saveReviewToAPI function
        const success = await saveReviewToAPI(review);

        if (success) {
          // Reset form and hide
          form.reset();
          toggleReviewForm();

          // Clear image preview
          const imagePreview = document.getElementById('image-preview');
          if (imagePreview) {
            imagePreview.innerHTML = '';
          }

          // Show success message
          const notification = document.createElement('div');
          notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #d4edda;
            color: #155724;
            border: 1px solid #c3e6cb;
            border-radius: 8px;
            padding: 16px;
            z-index: 10000;
            max-width: 400px;
            font-family: Arial, sans-serif;
            font-size: 14px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            opacity: 0;
            transform: translateY(-20px);
            transition: all 0.3s ease;
          `;
          notification.innerHTML = `
            <div style="display: flex; align-items: center; gap: 12px;">
              <span style="font-size: 18px; font-weight: bold;">✓</span>
              <span>Thank you for your review! It will be published after moderation.</span>
              <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
            </div>
          `;
          document.body.appendChild(notification);
          setTimeout(() => {
            notification.style.opacity = '1';
            notification.style.transform = 'translateY(0)';
          }, 10);
          setTimeout(() => {
            if (notification.parentElement) {
              notification.style.opacity = '0';
              notification.style.transform = 'translateY(-20px)';
              setTimeout(() => notification.remove(), 300);
            }
          }, 5000);

          // Show persistent loading status during reload
          submitBtn.textContent = 'Review submitted! Reloading...';
          submitBtn.disabled = true;

          // Reload page to show updated reviews
          window.location.reload();
        } else {
          // Show error notification
          const notification = document.createElement('div');
          notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #f8d7da;
            color: #721c24;
            border: 1px solid #f5c6cb;
            border-radius: 8px;
            padding: 16px;
            z-index: 10000;
            max-width: 400px;
            font-family: Arial, sans-serif;
            font-size: 14px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            opacity: 0;
            transform: translateY(-20px);
            transition: all 0.3s ease;
          `;
          notification.innerHTML = `
            <div style="display: flex; align-items: center; gap: 12px;">
              <span style="font-size: 18px; font-weight: bold;">✕</span>
              <span>Failed to submit review. Please try again.</span>
              <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
            </div>
          `;
          document.body.appendChild(notification);
          setTimeout(() => {
            notification.style.opacity = '1';
            notification.style.transform = 'translateY(0)';
          }, 10);
          setTimeout(() => {
            if (notification.parentElement) {
              notification.style.opacity = '0';
              notification.style.transform = 'translateY(-20px)';
              setTimeout(() => notification.remove(), 300);
            }
          }, 5000);
        }
      } catch (error) {
        console.error('Review submission error:', error);
        // Show error notification
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          padding: 16px;
          z-index: 10000;
          max-width: 400px;
          font-family: Arial, sans-serif;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(-20px);
          transition: all 0.3s ease;
        `;
        notification.innerHTML = `
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 18px; font-weight: bold;">✕</span>
            <span>An error occurred. Please try again.</span>
            <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
          </div>
        `;
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.style.opacity = '1';
          notification.style.transform = 'translateY(0)';
        }, 10);
        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-20px)';
            setTimeout(() => notification.remove(), 300);
          }
        }, 5000);
      } finally {
        // Reset button state
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    };

    // Initialize star rating input
    initStarRating();

    // Initialize image upload
    initImageUpload();

    // Load initial reviews
    loadInitialReviews();
  }

  async function loadInitialReviews() {
    try {
      const reviews = await loadReviewsFromAPI();
      renderReviews(reviews);
    } catch (error) {
      console.error('Failed to load initial reviews:', error);
    }
  }

  function initImageUpload() {
    const imageInput = document.getElementById('review-images');
    const imagePreview = document.getElementById('image-preview');

    if (!imageInput || !imagePreview) return;

    imageInput.addEventListener('change', handleImageUpload);

    function handleImageUpload(event) {
      const files = Array.from(event.target.files);
      const maxFiles = 1;
      const maxSize = 5 * 1024 * 1024; // 5MB
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

      // Validate files
      const validFiles = files.filter(file => {
        if (!allowedTypes.includes(file.type)) {
          showNotification(`File "${file.name}" is not a supported image format. Please use JPG, PNG, GIF, or WebP.`, 'error');
          return false;
        }
        if (file.size > maxSize) {
          showNotification(`File "${file.name}" is too large. Maximum size is 5MB.`, 'error');
          return false;
        }
        return true;
      });

      // Check total count
      const currentImages = imagePreview.children.length;
      if (currentImages + validFiles.length > maxFiles) {
        showNotification(`You can upload a maximum of ${maxFiles} image. You currently have ${currentImages} image.`, 'error');
        return;
      }

      // Add valid files to preview
      validFiles.forEach(file => {
        const reader = new FileReader();
        reader.onload = function(e) {
          const previewItem = document.createElement('div');
          previewItem.className = 'vc-pd-image-preview-item';

          previewItem.innerHTML = `
            <img src="${e.target.result}" alt="Preview">
            <button type="button" class="vc-pd-image-remove" onclick="removeImage(this)">×</button>
          `;

          // Store file data for form submission
          previewItem._file = file;
          imagePreview.appendChild(previewItem);
        };
        reader.readAsDataURL(file);
      });

      // Clear input
      event.target.value = '';
    }

    // Remove image function (global scope for onclick)
    window.removeImage = function(button) {
      button.closest('.vc-pd-image-preview-item').remove();
    };

    // Image modal functionality with review details
    window.openImageModal = function(imageUrl, element = null) {
      // Create modal if it doesn't exist
      let modal = document.getElementById('vc-pd-image-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'vc-pd-image-modal';
        modal.innerHTML = `
          <div class="vc-pd-image-modal-content">
            <div class="vc-pd-image-modal-left">
              <img id="vc-pd-image-modal-img" src="" alt="">
            </div>
            <div class="vc-pd-image-modal-right" id="vc-pd-image-modal-right">
              <!-- Review content will be inserted here -->
            </div>
            <button class="vc-pd-image-modal-close" onclick="closeImageModal()">×</button>
          </div>
        `;
        document.body.appendChild(modal);

        // Close on background click
        modal.addEventListener('click', function(e) {
          if (e.target === modal) {
            closeImageModal();
          }
        });

        // Close on escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && modal.style.display === 'flex') {
            closeImageModal();
          }
        });
      }

      // Set image
      document.getElementById('vc-pd-image-modal-img').src = imageUrl;

      // Set review content if element has data attributes
      const rightPanel = document.getElementById('vc-pd-image-modal-right');
      if (element && element.dataset && rightPanel) {
        const author = element.dataset.author;
        const rating = parseInt(element.dataset.rating) || 0;
        const content = element.dataset.content;

        if (author && rating && content) {
          const stars = Array.from({ length: 5 }, (_, i) => {
            return `<span class="vc-pd-star ${i < rating ? 'filled' : ''}">★</span>`;
          }).join('');

          rightPanel.innerHTML = `
            <div class="vc-pd-modal-review-header">
              <div class="vc-pd-modal-review-author">${author}</div>
              <div class="vc-pd-modal-review-rating">${stars}</div>
            </div>
            <div class="vc-pd-modal-review-content">${content}</div>
          `;
          rightPanel.style.display = 'block';
        } else {
          rightPanel.style.display = 'none';
        }
      } else if (rightPanel) {
        rightPanel.style.display = 'none';
      }

      // Show modal
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    window.closeImageModal = function() {
      const modal = document.getElementById('vc-pd-image-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    };
  }

  function initStarRating() {
    const ratingContainers = document.querySelectorAll('.vc-pd-rating-input');

    ratingContainers.forEach(container => {
      const labels = container.querySelectorAll('label');

      // Function to update visual state
      function updateStars(selectedRating) {
        labels.forEach((label, index) => {
          if (index < selectedRating) {
            label.classList.add('active');
            label.style.color = '#ffd700';
          } else {
            label.classList.remove('active');
            label.style.color = '#ddd';
          }
        });
      }

      // Function to reset to current selection
      function resetToSelection() {
        const checkedRadio = container.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          const currentRating = parseInt(checkedRadio.value);
          updateStars(currentRating);
        } else {
          // No selection, reset all
          labels.forEach(label => {
            label.classList.remove('active');
            label.style.color = '#ddd';
          });
        }
      }

      labels.forEach((label, index) => {
        // Click handler
        label.addEventListener('click', function() {
          const rating = parseInt(this.dataset.rating);

          // Update radio button
          const radio = document.getElementById(`rating-${rating}`);
          if (radio) {
            radio.checked = true;
          }

          // Update visual state
          updateStars(rating);
        });

        // Hover effects
        label.addEventListener('mouseenter', function() {
          const rating = index + 1; // Since labels are 0-4, rating is 1-5
          updateStars(rating);
        });

        label.addEventListener('mouseleave', function() {
          resetToSelection();
        });
      });

      // Initialize state
      resetToSelection();
    });
  }

  async function saveReviewToAPI(review) {
    const section = document.querySelector('[data-section-type="vc-product"]') || document.querySelector('#vcp-root');
    const productId = section?.dataset.productId;
    const customerId = section?.dataset.customerId;

    if (!productId || !customerId) {
      console.error('Missing product ID or customer not logged in');
      return false;
    }

    try {
      // Create FormData for file uploads
      const formData = new FormData();
      formData.append('productId', productId);
      formData.append('customerId', customerId);
      formData.append('rating', review.rating);
      formData.append('author', review.author);
      formData.append('content', review.content);

      // Add images if any
      if (review.images && review.images.length > 0) {
        review.images.forEach((file) => {
          formData.append('images', file);
        });
      }

      console.log('🌐 Sending review POST to '+window.VEDHACART_CONFIG.serverUrl);

      const response = await fetch(`${window.VEDHACART_CONFIG.serverUrl}/reviews/save`, {
        method: 'POST',
        body: formData
      });

      console.log('🌐 Response status:', response.status);

      let result;
      try {
        result = await response.json();
      } catch (err) {
        console.error('Failed to parse JSON from backend:', err);
        return false;
      }

      console.log('🧾 Backend JSON result:', result);
      return !!result.ok;
    } catch (error) {
      console.error('Error saving review:', error);
      return false;
    }
  }

  async function loadReviewsFromAPI() {
    const section = document.querySelector('[data-section-type="vc-product"]') || document.querySelector('#vcp-root');
    const productId = section?.dataset.productId;

    if (!productId) {
      return [];
    }

    try {
      const response = await fetch(`${window.VEDHACART_CONFIG.serverUrl}/reviews/load?productId=${productId}`);
      const reviews = await response.json();
      return reviews; 
    } catch (error) {
      console.error('Error loading reviews:', error);
      return [];
    }
  }

  function renderReviews(reviews) {
    const reviewsContainer = document.getElementById('vc-pd-reviews-list');
    const reviewsCount = document.getElementById('vc-pd-reviews-count');

    if (!reviewsContainer) return;

    // Update count
    if (reviewsCount) {
      reviewsCount.textContent = `${reviews.length} ${reviews.length === 1 ? 'review' : 'reviews'}`;
    }

    // Clear existing reviews
    reviewsContainer.innerHTML = '';

    if (reviews.length === 0) {
      reviewsContainer.innerHTML = '<p class="vc-pd-no-reviews">No reviews yet. Be the first to leave a review!</p>';
      return;
    }

    // Render each review
    reviews.forEach(review => {
      const reviewElement = document.createElement('div');
      reviewElement.className = 'vc-pd-review-item';

      // Star rating
      const stars = Array.from({ length: 5 }, (_, i) => {
        return `<span class="vc-pd-star ${i < review.rating ? 'filled' : ''}">★</span>`;
      }).join('');

      // Images - handle both string URLs and object formats
      const imagesHtml = review.images && review.images.length > 0
        ? review.images.map(img => {
            const url = typeof img === 'string' ? img : img.url;
            return `
              <img src="${url}" alt="Review image" class="vc-pd-review-image"
                   data-author="${review.author.replace(/"/g, '"')}"
                   data-rating="${review.rating}"
                   data-content="${review.content.replace(/"/g, '"')}"
                   onclick="openImageModal('${url}', this)">
            `;
          }).join('')
        : '';

      reviewElement.innerHTML = `
        <div class="vc-pd-review-header">
          <div class="vc-pd-review-author">${review.author}</div>
          <div class="vc-pd-review-rating">${stars}</div>
        </div>
        <div class="vc-pd-review-date">${new Date(review.date).toLocaleDateString()}</div>
        <div class="vc-pd-review-content">${review.content}</div>
        ${imagesHtml ? `<div class="vc-pd-review-images">${imagesHtml}</div>` : ''}
      `;

      reviewsContainer.appendChild(reviewElement);
    });
  }

  /* ===== Notification System ===== */
  window.showNotification = function(message, type = 'info') {
    console.log('🔔 Showing notification:', message, type);

    // Simple version first - just create and show
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#d4edda' : type === 'error' ? '#f8d7da' : '#d1ecf1'};
      color: ${type === 'success' ? '#155724' : type === 'error' ? '#721c24' : '#0c5460'};
      border: 1px solid ${type === 'success' ? '#c3e6cb' : type === 'error' ? '#f5c6cb' : '#bee5eb'};
      border-radius: 8px;
      padding: 16px;
      z-index: 10000;
      max-width: 400px;
      font-family: Arial, sans-serif;
      font-size: 14px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.3s ease;
    `;

    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 18px; font-weight: bold;">${type === 'success' ? '✓' : type === 'error' ? '✕' : 'ℹ'}</span>
        <span>${message}</span>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 20px; cursor: pointer; margin-left: auto;">×</button>
      </div>
    `;

    document.body.appendChild(notification);
    console.log('✅ Notification added to DOM');

    // Show with animation
    setTimeout(() => {
      notification.style.opacity = '1';
      notification.style.transform = 'translateY(0)';
    }, 10);

    // Auto-remove
    setTimeout(() => {
      if (notification.parentElement) {
        notification.style.opacity = '0';
        notification.style.transform = 'translateY(-20px)';
        setTimeout(() => notification.remove(), 300);
        console.log('🗑️ Notification removed');
      }
    }, 5000);
  };

  // Reset Buy Now button and restore cart when page is shown (handles browser back from checkout)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      const buyButton = document.querySelector('[data-pd-buy]');
      if (buyButton) {
        buyButton.textContent = 'Buy now';
        buyButton.removeAttribute('aria-busy');
        buyButton.disabled = false;
        buyButton.classList.remove('vc-pd-buy--disabled');
      }
      // Restore cart to pre-buy-now state
      restoreBuyNowCart();
    }
  });

  document.addEventListener('DOMContentLoaded', () => { init(); });
  document.dispatchEvent(new Event('vc:cart:updated'));

})();